module.exports = __webpack_public_path__ + "img/ford-used.55b0694e.png";